/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkspaceRestrictedEventWord } from '../models/WorkspaceRestrictedEventWord';
import type { WorkspaceRestrictedEventWordCreateRequest } from '../models/WorkspaceRestrictedEventWordCreateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WorkspaceRestrictedEventWordService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List Restricted Event Word
   * @param slug
   * @returns WorkspaceRestrictedEventWord Successful Response
   * @throws ApiError
   */
  public listRestrictedEventWordV1WorkspaceSlugRestrictedEventWordGet(
    slug: string
  ): CancelablePromise<Array<WorkspaceRestrictedEventWord>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/restricted_event_word',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Restricted Event Word
   * @param slug
   * @param requestBody
   * @returns WorkspaceRestrictedEventWord Successful Response
   * @throws ApiError
   */
  public createRestrictedEventWordV1WorkspaceSlugRestrictedEventWordPost(
    slug: string,
    requestBody: WorkspaceRestrictedEventWordCreateRequest
  ): CancelablePromise<WorkspaceRestrictedEventWord> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/restricted_event_word',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        402: `Payment Required`,
        409: `Conflict`,
        412: `Precondition Failed`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Restricted Event Word
   * @param restrictedEventWordId
   * @param slug
   * @returns void
   * @throws ApiError
   */
  public deleteRestrictedEventWordV1WorkspaceSlugRestrictedEventWordRestrictedEventWordIdDelete(
    restrictedEventWordId: number,
    slug: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/workspace/{slug}/restricted_event_word/{restricted_event_word_id}',
      path: {
        restricted_event_word_id: restrictedEventWordId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
